module.exports = "pegasus_template/assets/theme5/facebook-icon-1.png";